/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Actions_Aria_LabelInputs */

const en_speakers_actions_aria_label = /** @type {(inputs: Speakers_Actions_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speaker actions`)
};

const fr_speakers_actions_aria_label = /** @type {(inputs: Speakers_Actions_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions d'intervenant`)
};

const de_speakers_actions_aria_label = /** @type {(inputs: Speakers_Actions_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprechermaßnahmen`)
};

const it_speakers_actions_aria_label = /** @type {(inputs: Speakers_Actions_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azioni dell'oratore`)
};

const ru_speakers_actions_aria_label = /** @type {(inputs: Speakers_Actions_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Действия выступающего`)
};

const es_speakers_actions_aria_label = /** @type {(inputs: Speakers_Actions_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acciones del orador`)
};

const zh_cn2_speakers_actions_aria_label = /** @type {(inputs: Speakers_Actions_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发言人行动`)
};

const ja_speakers_actions_aria_label = /** @type {(inputs: Speakers_Actions_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スピーカーの行動`)
};

const hi_speakers_actions_aria_label = /** @type {(inputs: Speakers_Actions_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वक्ता की कार्रवाइयां`)
};

const pt_pt2_speakers_actions_aria_label = /** @type {(inputs: Speakers_Actions_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ações do orador`)
};

/**
* | output |
* | --- |
* | "Speaker actions" |
*
* @param {Speakers_Actions_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_actions_aria_label = /** @type {((inputs?: Speakers_Actions_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Actions_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speakers_actions_aria_label(inputs)
	if (locale === "de") return de_speakers_actions_aria_label(inputs)
	if (locale === "it") return it_speakers_actions_aria_label(inputs)
	if (locale === "ru") return ru_speakers_actions_aria_label(inputs)
	if (locale === "es") return es_speakers_actions_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_speakers_actions_aria_label(inputs)
	if (locale === "ja") return ja_speakers_actions_aria_label(inputs)
	if (locale === "hi") return hi_speakers_actions_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_speakers_actions_aria_label(inputs)
	return en_speakers_actions_aria_label(inputs)
});